module.exports = __webpack_public_path__ + "media/images/open_x_logo-62f50abdd1fe3d3936390cba067f52c1.png";